import { memoize } from "lodash";
import getCoreUIStore from "../core/core-ui-store";
import { apiCallAssignClientToKhattabat } from "../../api/khattbat-api/api-call-assign-client-to-khattaba";
import getCorePopUpStore from "../core/core-popup-store";
import getDashBoardStore from "../dashboard-store";
import { computed, observable } from "mobx";
import { isPositiveNumber } from "et3-type-guards";
import { E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE, TUserType } from "../../Types";

class KhattabatAssignStore {
  selectedClientType = observable.box<TUserType>(
    E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.REAL
  );
  checkifNewClientsOrTestersAvailable = computed(() => {
    return isPositiveNumber(
      getKhattabatAssignStore().getTotalUnassignedNewClientsAndTesters.get()
    );
  });

  toggleSelectedClientType = () => {
    const isRealClientSelected =
      this.selectedClientType.get() ===
      E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.REAL;
    this.selectedClientType.set(
      isRealClientSelected
        ? E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.TESTER
        : E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.REAL
    );
  };

  succesfullClientAssignment = () => {
    getDashBoardStore().decrementUnassignedNewClients();
    getCorePopUpStore().showSuccessMessage("SUCCESS");
  };

  assignClientToKhattaba = async () => {
    getCorePopUpStore().closeConfirmationPopUps();
    if (!this.checkifNewClientsOrTestersAvailable.get()) {
      getCorePopUpStore().showAlertMessage("NO_NEW_CLIENTS_AVAILABLE");
      return;
    }
    getCoreUIStore().setIsLoading("KHATTABAT_NEW_CLIENTS", true);
    const { code, status } = await apiCallAssignClientToKhattabat({
      userType: this.selectedClientType.get()
    });
    if (status === "ERROR") {
      if (code === "NO_NEW_CLIENTS_AVAILABLE")
        await getDashBoardStore().getKhattabatDashboardData();
      getCorePopUpStore().showAlertMessage(code);
    } else {
      this.succesfullClientAssignment();
    }
    getCoreUIStore().setIsLoading("KHATTABAT_NEW_CLIENTS", false);
  };

  getTotalUnassignedNewClientsAndTesters = computed(() => {
    const totalRealUsers =
      getDashBoardStore().totalUnassignedKhattabatClients.get();

    const totalTesterUsers =
      getDashBoardStore().totalUnassignedKhattabatTesters.get();

    const totalUnassignedNewClientsAndTesters =
      totalRealUsers + totalTesterUsers;
    return totalUnassignedNewClientsAndTesters;
  });
}

export const getKhattabatAssignStore = memoize(
  () => {
    return new KhattabatAssignStore();
  },
  () => 1
);

export default getKhattabatAssignStore;
